
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14.756","height":"10.635"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"data-name":"Path 335","d":"M1.414 6.008l3.47 3.627 8.458-8.221","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-miterlimit":"22.926","stroke-width":"2"}})])
          )
        }
      }
    